import { render } from "./ModalTunnel.vue?vue&type=template&id=2c3acc61&scoped=true&ts=true"
import script from "./ModalTunnel.vue?vue&type=script&lang=ts"
export * from "./ModalTunnel.vue?vue&type=script&lang=ts"

import "./ModalTunnel.vue?vue&type=style&index=0&id=2c3acc61&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3acc61"]])

export default __exports__